import React, { useEffect, useState } from "react";
import { Container, Row, Col, Input, InputGroup } from "reactstrap";
import { withStore } from "contexts/store-context";
import { withToast } from "contexts/toast-context";
import Head from "components/basics/head";
import MktAnnouncement from "components/mkt/mkt-announcement";
import MktNav from "components/navs/mkt-nav";
import MktFooter from "components/mkt/mkt-footer";
import { ProviderMktCard } from "components/provider/provider-card";
import FaWrapper from "components/vendors/fa-wrapper";
import PaginationWrapper from "components/bootstrap/pagination-wrapper";

const MktFeaturedStylistsRoute = (props) => {
  const { store, toast } = props;
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [metaData, setMetaData] = useState({
    page: 0,
    pageSize: 10,
    totalRecords: 0,
  });

  // Hooks
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (page !== metaData?.page) {
      setMetaData({
        ...metaData,
        page: page,
      });
      fetchData(page);
    }
  }, [page]);

  // Methods
  const fetchData = async (pageNumber) => {
    try {
      setLoading(true);
      let model = await store.query("provider", {
        page: pageNumber || metaData?.page,
        pageSize: metaData?.pageSize,
        search: search,
        providersList: true,
        status: "active",
        include: "location",
      });
      setProviders(model);
      setMetaData({
        ...metaData,
        totalRecords: model?.meta?.totalCount,
      });
      setTotalPages(model?.meta?.totalPages);
    } catch (e) {
      toast.showError(e);
    } finally {
      setLoading(false);
    }
  };

  const searchChangeHandle = () => {
    setPage(0);
    setMetaData({
      ...metaData,
      page: 0,
    });
    fetchData();
  };

  // Render
  return (
    <div className="route">
      <Head title="Blush - Our Services" />
      <MktAnnouncement />
      <MktNav />
      <main className="mkt-main">
        <section className="mkt-section sm">
          <div className="mkt-section-body lg">
            <Container>
              <div className="flex flex-between align-center mkt-section-stylist-titlecontainer">
                <h4 className="mkt-section-stylist-title">
                  {"Featured Stylists"}
                </h4>
                <InputGroup className="mkt-section-search-container">
                  <Input
                    id="search"
                    type="text"
                    value={search}
                    placeholder="Search..."
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <div
                    className="mkt-styled-icon"
                    onClick={() => searchChangeHandle()}
                  >
                    <FaWrapper icon={"search"} />
                  </div>
                </InputGroup>
              </div>
              <div className={"card section border-0"}>
                <Row>
                  {providers.map((provider) => (
                    <Col md="4" lg="3" className="mb-15" key={provider.id}>
                      <ProviderMktCard provider={provider} loading={loading} />
                    </Col>
                  ))}
                </Row>
              </div>
              <div className="flex flex-row flex-end">
                {totalPages > 1 ? (
                  <PaginationWrapper
                    meta={{ ...metaData, page: page }}
                    setPage={(p) => setPage(p)}
                  />
                ) : null}
              </div>
            </Container>
          </div>
        </section>
      </main>
      <MktFooter />
    </div>
  );
};

export default withStore(withToast(MktFeaturedStylistsRoute));
